import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-documents-help',
  templateUrl: './documents-help.component.html',
  styleUrls: ['./documents-help.component.scss']
})
export class DocumentsHelpComponent implements OnInit {

  title = 'FORMATO DE ENTREGA PARA ';

  linksInterest = [];

  constructor(
    public dialogRef: MatDialogRef<DocumentsHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title+=this.data.document;
    this.getLinksInterest(this.data.document);
   }

  ngOnInit() {
  }

  onClose(){
    this.dialogRef.close({action:'close'});
  }

  getLinksInterest(document){
    switch (document) {
      case 'LA COPIA DEL COMPROBANTE DE PAGO DE INSCRIPCIÓN':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL CERTIFICADO DE BACHILLERATO O EQUIVALENTE':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'LA CURP':
        this.linksInterest = [
          {
            name: 'Descarga de CURP',
            link: 'https://www.gob.mx/curp/'
          },
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL ACTA DE NACIMIENTO':
        this.linksInterest = [
          {
            name: 'Descarga Acta de Nacimiento',
            link: 'https://www.gob.mx/ActaNacimiento/'
          },
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'LOS RESULTADOS DE ANÁLISIS CLÍNICOS':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL NÚMERO DE SEGURO SOCIAL':
        this.linksInterest = [
          {
            name: 'Obtener Número de Seguro Social',
            link: 'https://serviciosdigitales.imss.gob.mx/gestionAsegurados-web-externo/asignacionNSS'
          },
          {
            name: 'Obtener Constancia de Vigencia de Derechos',
            link: 'https://serviciosdigitales.imss.gob.mx/gestionAsegurados-web-externo/vigencia'
          },
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL CERTIFICADO DE LICENCIATURA O EQUIVALENTE':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL TITULO DE LICENCIATURA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'LA CEDULA DE LICENCIATURA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL ACTA DE EXAMEN DE LICENCIATURA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL CERTIFICADO DE MAESTRIA O EQUIVALENTE':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL TITULO DE MAESTRIA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'LA CEDULA DE MAESTRIA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'EL ACTA DE EXAMEN DE MAESTRIA':
        this.linksInterest = [
          {
            name: 'Comprimir archivos PDF',
            link: 'https://www.ilovepdf.com/es/comprimir_pdf'
          }
        ]
      break;
      case 'LA FOTO':
        this.linksInterest = [
          {
            name: 'Comprimir imagenes',
            link: 'https://www.iloveimg.com/es/comprimir-imagen'
          }
        ]
      break;
    }
  }

  openlinkInterest(l){
    window.open(l.link, '_blank');
  }
  
}
